// utils/apiHelpers.ts
export const handleApiError = (
  error: any,
  navigate: (path: string) => void
) => {
  const message = error.response?.data?.message || "Something went wrong!";
  if (message === "Invalid or expired token.") {
    localStorage.clear();
    window.dispatchEvent(new Event("loginStatusChanged"));
    navigate("/authuser/login");
  }
  return message;
};
